import lang from '../../../../../../lib/language';
import { InfoStatusType } from '../../../../../../lib/models/market-data/types';

import styles from './InfoStatus.module.scss';

const InfoStatus = ({ type }: { type: InfoStatusType }) => (
  <span className={styles.infoStatus}>
    { type === 'none' && lang.performanceRangeTextToday() }
    { type === 'pre' && lang.commonMarketHoursPre() }
    { type === 'after' && lang.commonMarketHoursAfter() }
    { type === 'close' && lang.commonMarketHoursAtClose() }
  </span>
);

export default InfoStatus;
